import api from "../index";

// Get AI configuration
export const getAIConfig = async () => {
  return await api.get("/settings/ai-config");
};

// Update AI configuration
export const updateAIConfig = async (data: any) => {
  return await api.put("/settings/ai-config", data);
};
